<template>
  <div class="py-10">
    <div class="flex flex-column">
      <v-icon size='5vw' color='#aaa' class="py-5">mdi-warehouse</v-icon>
      <h5 class="text-center" v-if='$getRight("warehouseView")'>
        Please <router-link style="color: #9e9bd2" :to='{name: "WarehousesList"}'>select</router-link> a warehouse
      </h5>
      <h5 class="text-center" v-else>
        You don't have available warehouses
      </h5>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SelectWarehouse',
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse'])
  }
}
</script>

<style scoped lang="scss">

</style>
